import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        property_statuses: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {}
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        loading: state => state.loading,
        property_statuses: state => state.property_statuses,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setLoading(state, data) {
            state.loading = data;
        },
        setPropertyStatuses(state, data) {
            state.property_statuses = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {}
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getPropertyStatuses({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getPropertyStatuses(filters);
                commit('setPropertyStatuses', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

        async createPropertyStatuses({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createPropertyStatuses(data);
                ElMessage.success('property category created successfully!');
                commit('setDialogVisible', false)
                dispatch('getPropertyStatuses', {
                    paginate: true
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating property category!');
            }
        },
        async editPropertyStatuses({dispatch, commit}, data) {
            try {
                await api.editPropertyStatus(data);
                ElMessage.success('property category updated successfully!');
                commit('setDialogVisible', false)
                dispatch('getPropertyStatuses', {
                    paginate: true
                })
            } catch (e) {
                ElMessage.error('Error updating property category');
            }
        },
        async deletePropertyStatuses({commit, dispatch}, data) {
            commit('setLoading', true);
            try {
                const response = await api.deletePropertyStatus(data);
                commit('setLoading', false);
                dispatch('getPropertyStatuses', {
                    paginate: true
                })
                if (response.status === 401) {
                    ElMessage.warning({
                        message: response.message,
                        duration: 10000
                    });
                } else {
                    ElMessage.success({
                        message: response.message,
                        duration: 10000
                    });
                }
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

    }
}
